import { render, staticRenderFns } from "./CustomCollapseComponent.vue?vue&type=template&id=01916946"
import script from "./CustomCollapseComponent.vue?vue&type=script&lang=js"
export * from "./CustomCollapseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports